module.exports = __webpack_public_path__ + "static/media/training.ec2a50d7.svg";